import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=85408318&scoped=true&"
import script from "./RoleForm.vue?vue&type=script&lang=js&"
export * from "./RoleForm.vue?vue&type=script&lang=js&"
import style0 from "./RoleForm.vue?vue&type=style&index=0&id=85408318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85408318",
  null
  
)

export default component.exports